import { FC } from "react";
import Chip from "@mui/material/Chip";

/** Marks a feature that only SuperKudu (HG internal) users can see. */
export const SuperKuduChip: FC<{ "data-testid"?: string }> = (props) => (
  <Chip
    label="SuperKudu"
    size="small"
    color="secondary"
    variant="outlined"
    sx={{ height: 18, fontSize: 10, flexShrink: 0 }}
    {...props}
  />
);
